import SalonModal from 'components/dialog/SalonModal.component';
import Button from 'components/form/Button.component';
import Icon from 'components/generic/Icon.component';
import IconStatus from 'components/generic/IconStatus.component';
import { useTranslation } from 'providers/GILT.provider';

import CN from './ClientProfileSaveErrorModal.module.scss';

export const ClientProfileSaveErrorModal = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  return (
    <SalonModal tag="ClientProfileSaveErrorModal" isOpen={isOpen} variant="noFooter">
      <SalonModal.Header>
        <div className={CN.closeButtonContainer}>
          <Button variant="empty" onClick={onClose}>
            <Icon variant="close" variantInvert />
          </Button>
        </div>
      </SalonModal.Header>
      <SalonModal.Body>
        <IconStatus variant="alert" width="lg" space="no">
          <Icon variant="alert" width="l1" />
        </IconStatus>
        <div className={CN.modalContent}>
          <span className={CN.modalTitle}>{t('composite.clientProfile.saveErrorModal.title')}</span>
          <span className={CN.modalText}>{t('composite.clientProfile.saveErrorModal.description')}</span>
        </div>
      </SalonModal.Body>
    </SalonModal>
  );
};
